import FAQArticlePage from "./FAQArticle";

const data = {
  title: "I don't recognize this charge — what should I do?",
  category: "Billing & Payments",
  content: `If you don't recognize a charge, please follow these steps before contacting us:

Step 1: Check your email
- Look for receipts and transaction confirmation emails
- Check your spam/junk folders
- Search for emails from novavertextech.com or Nova Vertex LTD

Step 2: Review the charge details
- The charge may appear under our parent company name "Nova Vertex LTD"
- Check if a family member or colleague may have used your card
- Verify if you signed up for a free trial that converted to a paid subscription

Step 3: Still don't recognize it?
- Contact our support team immediately
- We will investigate the charge and provide a full transaction history
- If the charge was unauthorized, we will issue a refund and help secure your account

To speed up the investigation, please provide:
- The exact date and amount of the charge
- The last 4 digits of the card charged
- Any email addresses you may have used to sign up

We take unrecognized charges very seriously and will work to resolve this quickly.

Email: support@novavertextech.com
Phone: +44 7520 663474`,
};

export default function BPQ2Page() {
  return <FAQArticlePage data={data} />;
}